import intro from '../pages/intro/page.js';
import outro from '../pages/outro/page.js';
import game from '../pages/matching/page.js';

let parent;
let _clb;

const intro_page=()=>intro.show({
	cls:'',
	header:'Find the match',
	desc:[
		'You\'ve arrived in Atlanta! Let\'s go for a walk to check out the city.',
		'Always use the crosswalks when crossing the street.'
	],
	clb:game_page,
	parent
});

const game_page=()=>game.show({
	parent,
	clb:outro_page
});

const outro_page=()=>outro.show({
	cls:'matching',
	header:'Way to go!',
	desc:[
		'You crossed the city streets like a champion and made your way to the Martin Luther King, Jr. Memorial Park.'
	],
	parent,
	clb:()=>{
		if(_clb) _clb();
		_clb = undefined;
	}
})

const _ext={
	start:({container,clb})=>{
		parent = container;
		_clb=clb;
		intro_page();
	},
	stop:()=>{
		game.hide();
	}
}

export default _ext;
